import StartSale from './StartSale';

export default StartSale;
